import { DIContainer } from "Global/Base/DIContainer";
import { IAuthManager } from "OW.Remoting/Remoting/Auth/IAuthManager";
import { FormContentBuilder } from "../UI/DataBuilders/FormContentBuilder";
import { ISettingWindowFormBuilder } from "../UI/FormBuilders/ISettingWindowFormBuilder";
import { MessageType, MessageWindow } from "../UI/MessageWindow";
import { MessageButtonResult } from "../UI/UIManager";

/**
 * Třída poskytující statické metody pro interakci menu s aplikací.
 */
export class ApplicationControlMethods {
    /**
     * Otevře dialog s nastavením.
     */
    public static async openSettingsWindow(): Promise<MessageButtonResult> {
        const messageWindow = new MessageWindow(undefined, ["app-settings-window"]);
        const content = DIContainer.instance.create(ISettingWindowFormBuilder);
        messageWindow.contentBuilder = new FormContentBuilder(await content.build(messageWindow, null));
        messageWindow.type = MessageType.empty;

        return await messageWindow.show();
    }

    /**
     * Odhlásí uživatele a přesměruje na login stránku.
     */
    public static async logout(): Promise<void> {
        try {
            const authManager = DIContainer.instance.create(IAuthManager);
            await authManager.logout();
        } catch (error) {
            // nemá smysl nic zobrazovat, protože se stejně hned přesměruje na login stránku
        }
    }
}
